








import { Component, Vue } from 'vue-property-decorator';
import DefaultLayout from './layouts/Default.vue';

@Component({
    computed: {
        layout() {
            return `${this.$route.meta.layout || 'Default'}Layout`;
        },
    },
    components: {
        DefaultLayout,
    },
})
export default class Main extends Vue {
}
